// D:\xampp\htdocs\ErpapiSancReact\src\pages\mount\MyComponent.js

import React, { useEffect, useState } from 'react';

function MyComponent({ title }) {
  const [count, setCount] = useState(0);
  const [users, setUsers] = useState([]);
  const [name, setName] = useState("");

  console.log("Rendering...");

  useEffect(() => {
    console.log("Component mounted!");

    return () => {
      console.log("Component unmounted!");
    };
  }, []);


  // 🌐 API Call (Fake API)
  useEffect(() => {
    fetch("https://jsonplaceholder.typicode.com/users")
      .then(res => res.json())
      .then(data => setUsers(data))
      .catch(err => console.error("API error:", err));
  }, []);

  // ⏱️ Auto increment counter every second
  useEffect(() => {
    // const timer = setInterval(() => {
    //   setCount(prev => prev + 1);
    // }, 1000);

    // return () => clearInterval(timer); // Cleanup
  }, []);

  // 💾 Save & Load from LocalStorage
  useEffect(() => {
    const savedName = localStorage.getItem("my_name");
    if (savedName) {
      setName(savedName);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("my_name", name);
  }, [name]);


  return (
    <div style={{ padding: '20px' }}>
      <h1>{title}</h1>
      <p>This is a full page component with button and counter.</p>

      <button onClick={() => setCount(count + 1)}>Click Me</button>
      {/* <p>You clicked {count} times.</p> */}

      <hr />

      <h3>LocalStorage Name:</h3>
      <input
        type="text"
        placeholder="Enter your name"
        value={name}
        onChange={e => setName(e.target.value)}
        style={{ padding: '8px', marginBottom: '10px' }}
      />
      <p>Stored Name: <strong>{name}</strong></p>

      <hr />

      <h3>🌐 Users from API:</h3>
      <ul>
        {users.slice(0, 5).map(user => (
          <li key={user.id}>{user.name} ({user.email})</li>
        ))}
      </ul>
    </div>
  );
}

export default MyComponent;
